var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlucometryIconGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.595 10.788a2.601 2.601 0 1 1-5.202 0c0-1.437 2.601-5.4 2.601-5.4s2.601 3.963 2.601 5.4z",
    fill: "#54585A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.153 1.305H5.835a1.4 1.4 0 0 0-1.4 1.4V19.5a1.4 1.4 0 0 0 1.4 1.4h4.97v1.645h2.414V20.9h4.934a1.4 1.4 0 0 0 1.4-1.4V2.704a1.4 1.4 0 0 0-1.4-1.4zM10.034 19.22h-2.8a.84.84 0 0 1-.84-.84v-1.12a.84.84 0 0 1 .84-.84h2.8a.84.84 0 0 1 .84.84v1.12a.84.84 0 0 1-.84.84zm7.56-.84a.84.84 0 0 1-.84.84h-2.8a.84.84 0 0 1-.84-.84v-1.12a.84.84 0 0 1 .84-.84h2.8a.84.84 0 0 1 .84.84v1.12zm0-4.479a.84.84 0 0 1-.84.84h-9.52a.84.84 0 0 1-.84-.84V4.104a.84.84 0 0 1 .84-.84h9.519a.84.84 0 0 1 .84.84v9.798z",
    fill: "#54585A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlucometryIconGray);
export default __webpack_public_path__ + "static/media/glucometryIconGray.7d3f491e.svg";
export { ForwardRef as ReactComponent };